import { createStore } from "vuex";
import {
  Language,
  DEFAULT_LANGUAGE,
  LANGUAGE_NAMES,
  SPEECH_LANG_CODES,
  normalizeLanguage,
} from "@/constants/languages";
import { i18n } from "@/i18n/index.js";

// 지원 언어 목록 (enum 기반 생성)
const SUPPORTED_LANGUAGES = Object.values(Language).map((code) => ({
  code,
  name: LANGUAGE_NAMES[code],
}));

export default createStore({
  state: {
    currentLanguage: normalizeLanguage(localStorage.getItem("language")),
    supportedLanguages: SUPPORTED_LANGUAGES,
    userNo: localStorage.getItem("USER_NO") || null,
  },

  getters: {
    currentLanguage: (state) => state.currentLanguage,
    speechLangCode: (state) =>
      SPEECH_LANG_CODES[state.currentLanguage] || SPEECH_LANG_CODES[DEFAULT_LANGUAGE],
    supportedLanguages: (state) => state.supportedLanguages,
    currentLanguageInfo: (state) => {
      return (
        state.supportedLanguages.find(
          (l) => l.code === state.currentLanguage,
        ) || state.supportedLanguages[0]
      );
    },
    getUserNo: (state) => state.userNo,
  },

  mutations: {
    SET_LANGUAGE(state, lang) {
      state.currentLanguage = normalizeLanguage(lang);
      localStorage.setItem("language", state.currentLanguage);
      // i18n locale 동기화
      i18n.global.locale.value = state.currentLanguage;
    },
    SET_USER_NO(state, userNo) {
      state.userNo = userNo;

      if (userNo) {
        localStorage.setItem("USER_NO", userNo);
      } else {
        localStorage.removeItem("USER_NO");
      }
    },
  },
  

  actions: {
    setLanguage({ commit }, lang) {
      commit("SET_LANGUAGE", lang);
    },
  },
});
